import { EnergyType } from '@energy-retailer/constants';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { getPlans } from '@/app/queries';

import type { GetPlansParameters, PlanSchema } from '@energy-retailer/schema';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

const usePlans = (
  distributorParam: GetPlansParameters['distributor'],
  ntcParam: GetPlansParameters['ntc']
): {
  plans: PlanSchema[] | undefined;
  isFetching: boolean;
  status: 'error' | 'success' | 'pending';
  setPostcode: (_: GetPlansParameters['postcode']) => void;
  setDistributor: (_: GetPlansParameters['distributor']) => void;
  setNtc: (_: GetPlansParameters['ntc']) => void;
  setEnergyType: (_: GetPlansParameters['energyType']) => void;
  setCustomerType: (_: GetPlansParameters['customerType']) => void;
  setPromotionId: (_?: GetPlansParameters['promotionId']) => void;
} => {
  const { property } = useJoinFormStore();

  const [postcode, setPostcode] = useState<GetPlansParameters['postcode']>(
    property.address.postcode
  );
  const [distributor, setDistributor] =
    useState<GetPlansParameters['distributor']>(distributorParam);
  const [ntc, setNtc] = useState<GetPlansParameters['ntc']>(ntcParam);
  const [energyType, setEnergyType] = useState<
    GetPlansParameters['energyType']
  >(EnergyType.Electricity);
  const [customerType, setCustomerType] = useState<
    GetPlansParameters['customerType']
  >(property.customerType);
  const [promotionId, setPromotionId] = useState<
    GetPlansParameters['promotionId'] | undefined
  >(undefined);

  const planListQuery = useQuery({
    queryKey: [
      'plans',
      { postcode, distributor, ntc, energyType, promotionId, customerType },
    ],
    queryFn: getPlans,
  });

  const { data: planData, isFetching: isFetchingPlans, status } = planListQuery;

  const plans = planData as PlanSchema[] | undefined;

  return {
    plans,
    isFetching: isFetchingPlans,
    status,
    setPostcode,
    setDistributor,
    setNtc,
    setEnergyType,
    setPromotionId,
    setCustomerType,
  };
};

export { usePlans };
